import { GoalStatus } from '../../coaching-base/general';
import { CommitmentGoalHistory } from '../models/commitment-goal-history.model';

const inverseCanExpireLookup = [GoalStatus.DRAFT, GoalStatus.CLOSED];

export function goalHistoryMap(
    list: CommitmentGoalHistory[],
): CommitmentGoalHistory[] {
    if (!list || !list.length) {
        return [];
    }

    // TODO: check if closed goals should not have any new records on top
    const today = new Date().setHours(0, 0, 0, 0);

    const history: CommitmentGoalHistory[] = list.map((item) => {
        const ret: CommitmentGoalHistory = { ...item };

        switch (ret.statusId) {
            case GoalStatus.PRE_APPROVAL:
            case GoalStatus.UPDATING:
                ret.textClass = 'text-pending';
                break;
            case GoalStatus.ACTIVE:
                ret.textClass = 'text-active';
                break;
            case GoalStatus.PENDING_CLOSE:
                ret.textClass = 'text-expired';
                break;
            default:
                ret.textClass = 'text-close';
                break;
        }

        const eventDate = new Date(item.date).setHours(0, 0, 0, 0);
        const expiryDate = new Date(item.expectedAchievementDate).setHours(
            0,
            0,
            0,
            0,
        );

        // if not draft or closed, compare if event date is past the expiry
        if (
            !inverseCanExpireLookup.includes(ret.statusId) &&
            eventDate > expiryDate
        ) {
            ret.textClass = 'text-expired';
            ret.expired = true;
        }

        return ret;
    });

    // if active, no events happened after expiration, append a expired row copy
    const expired =
        !inverseCanExpireLookup.includes(history[0].statusId) &&
        history[0].date &&
        history[0].expectedAchievementDate &&
        today > new Date(history[0].date).setHours(0, 0, 0, 0) &&
        today >
            new Date(history[0].expectedAchievementDate).setHours(0, 0, 0, 0);
    if (expired) {
        const newExpired: CommitmentGoalHistory = { ...history[0] };
        newExpired.textClass = 'text-expired';
        newExpired.expired = true;

        const expiredDate = new Date(
            history[0].expectedAchievementDate.setHours(0, 0, 0, 0),
        );
        newExpired.date = new Date(
            expiredDate.setDate(new Date(expiredDate).getDate() + 1),
        );

        history.unshift(newExpired);
    }

    return history;
}
